import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";

// Cross-sell Sankey hover-focus — progressive enhancement only.
//
// The chart SVG is rendered server-side by conflux\reports\charts\sankey (PHP); this script just
// adds interactivity. Hovering a ribbon OR a node focuses every flow touching that service: the
// matching ribbons lift and the rest recede. Without JS the chart still displays fully (ribbons
// at their base opacity), so print/PDF and no-JS contexts are unaffected.
//
// Ribbons carry data-from / data-to (the service at each end); nodes carry data-node. Focusing a
// service name toggles classes the stylesheet styles (.is-focused on the SVG, .is-on / .is-dim on
// each ribbon) — no inline styles, so the look stays in _cross-sell-flow.scss.
export default obj => {
	if (!obj.length) {
		return;
	}
	obj.each(function () {
		const svg = this.querySelector(".report__chart-sankey-svg");
		if (!svg) {
			return;
		}
		const links = Array.from(svg.querySelectorAll(".report__chart-sankey-link"));
		const nodes = Array.from(svg.querySelectorAll(".report__chart-sankey-node"));
		if (!links.length) {
			return;
		}

		const focus = name => {
			svg.classList.add("is-focused");
			links.forEach(p => {
				const on = p.getAttribute("data-from") === name || p.getAttribute("data-to") === name;
				p.classList.toggle("is-on", on);
				p.classList.toggle("is-dim", !on);
			});
		};
		const clear = () => {
			svg.classList.remove("is-focused");
			links.forEach(p => p.classList.remove("is-on", "is-dim"));
		};

		// hovering a ribbon focuses its source service (its whole left→right journey set)
		links.forEach(p => {
			p.addEventListener("mouseenter", () => focus(p.getAttribute("data-from")));
			p.addEventListener("mouseleave", clear);
		});
		// hovering a node focuses every flow in or out of that service
		nodes.forEach(r => {
			const name = r.getAttribute("data-node");
			r.addEventListener("mouseenter", () => focus(name));
			r.addEventListener("mouseleave", clear);
		});
	});
};

